import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.8766 1.74676C11.1544 1.8857 11.267 2.22357 11.1281 2.50144L7.87889 8.99988L11.1281 15.4983C11.267 15.7762 11.1544 16.1141 10.8766 16.253C10.5987 16.3919 10.2608 16.2793 10.1219 16.0014L6.74688 9.25144C6.66771 9.09308 6.66771 8.90668 6.74688 8.74832L10.1219 1.99832C10.2608 1.72046 10.5987 1.60783 10.8766 1.74676Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
